import Experiments from '@wix/wix-experiments';
import { type FedopsLogger } from '@wix/fedops-logger';
import { InteractionName } from '../types/InteractionName';
import { type WidgetProps } from '../types/WidgetProps';
import { type AppIdentityParams } from './serverAPI/fetchPaymentMethods';

export const getAppIdentity = (props: WidgetProps): AppIdentityParams => ({
  appDefId: props.meta.appDefId,
  appInstanceId: props.meta.appInstanceId,
  auth: {
    appInstance: props.meta.appInstance,
    revalidateAppInstance: props.revalidateAppInstance,
  },
});

export type PreloadingData = {
  experiments: Experiments;
};

export const preloadData = (props: WidgetProps, fedopsLogger: FedopsLogger): PreloadingData => {
  fedopsLogger.interactionStarted(InteractionName.LoadExperiments);
  const experiments = new Experiments({
    useNewApi: true,
    scopes: ['payments', 'payments-checkout'],
    requestContext: {
      forSiteVisitors: {
        visitorId: props.meta.visitorId,
        siteOwnerId: props.meta.siteOwnerId,
      },
    },
    onError(error) {
      console.error('[express-widget] Error in loading experiments:', error);
    },
  });

  return {
    experiments,
  };
};
